import { createClient } from '@supabase/supabase-js';

// These values come from your Supabase project settings
// Go to: Project Settings > API
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
